import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import { sendExportRequest } from "features/Library/Common/utils/performanceUtils";
import messagesDataService from "../../services/messageDataService";

let abortController = new AbortController();

export const doMessageExport = (filterParams: BasePerformanceRequestFilterParams, name: string) => {
  return sendExportRequest(
    (abortController) => messagesDataService.getMessageExport(filterParams, abortController),
    name,
    abortController,
  );
};

export const doMessageDrillDownExport = (
  filterParams: BasePerformanceRequestFilterParams,
  sessionId: number,
  name: string,
) => {
  return sendExportRequest(
    (abortController) => messagesDataService.getMessageDrillDownExport(filterParams, sessionId, abortController),
    name,
    abortController,
  );
};
